module.exports = {
  ja: {
    name: "ja",
    default: true,
    path: `/`,
    label: `日本語`,
  },
  // en: {
  //   name: "en",
  //   default: false,
  //   path: `/en`,
  //   label: `English`,
  // },
  // ko: {
  //   name: "ko",
  //   default: false,
  //   path: `/ko`,
  //   label: `한국어`,
  // },
  // zh: {
  //   name: "zh",
  //   default: false,
  //   path: `/zh`,
  //   label: `中文`,
  // },
}

// locale: `en-US`,
// dateFormat: `DD/MM/YYYY`,
// siteLanguage: `en`,
// ogLanguage: `en_US`,
// defaultTitle: `Fulcrum Starter Korean`,
// defaultDescription: `Description Korean.`,
